import { render, staticRenderFns } from "./Overviews.vue?vue&type=template&id=32bb18d8&scoped=true&"
import script from "./Overviews.vue?vue&type=script&lang=js&"
export * from "./Overviews.vue?vue&type=script&lang=js&"
import style0 from "./Overviews.vue?vue&type=style&index=0&id=32bb18d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb18d8",
  null
  
)

export default component.exports